module.exports = __webpack_public_path__ + "static/media/favebiz-insights-logo.1e025b4f.svg";